module.exports = "/images/discoverus-1.png";